import { experimentsConfig } from '../experiments';
import type { ExperimentName, Variation } from '../types/VistaExperiment';

export function vistaExperimentsFromUbikUserContext(
    userContextExperiments: {
        [key: string]: string | undefined;
    },
    logger: {
        warn: (message: string) => void;
    }
) {
    return Object.keys(userContextExperiments)
        .filter(
            (experimentName): experimentName is ExperimentName =>
                experimentName in experimentsConfig
        )
        .map((experimentName) => {
            const variation = userContextExperiments[experimentName];
            const validVariations = [...experimentsConfig[experimentName].variations] as string[];

            if (variation && !validVariations.includes(variation)) {
                logger.warn(
                    `Unexpected variation "${variation}" for experiment "${experimentName}".`
                );
            }

            return {
                experimentKey: experimentName,
                variationKey: variation as Variation<typeof experimentName>,
            };
        });
}
